import { PdsErrorPage } from "@principal/design-system-react";
import React from 'react';

const NotFound = () => (
    <PdsErrorPage errorCode="404" linkHref={process.env.REACT_APP_ENTERPRISE_MEMBER_URL as string} linkText="Head back to the homepage"/>
)
export default NotFound;
